import ReportedContentScreenConnector from './ReportedContentScreenConnector';

export default ReportedContentScreenConnector;
